import { z } from 'zod';
export const ContentTestWidgetKey = 'content-test-widget:v1';
export const ContentTestWidgetKind = 'content_test';
export const CONTENT_TEST_ARTIFACT_KEY_PREFIX = 'content-test:';
const ContentTestVariantSchema = z.object({
    ordinal: z.number(),
    title: z.string(),
    contentBody: z.string().optional(),
    explanation: z.string().optional(),
    imagePrompt: z.string().optional(),
    generatedImageAssetId: z.string().optional(),
});
const ContentTestResultSchema = z.object({
    overallScore: z.number().optional(),
    insights: z.array(z.string()).optional(),
    variants: z.array(ContentTestVariantSchema).optional(),
});
const ContentTestPersonaSchema = z.object({
    id: z.string(),
    contentTestId: z.string(),
    personaId: z.string(),
    personaSnapshot: z.record(z.string(), z.unknown()),
    result: z.record(z.string(), z.unknown()).optional(),
    error: z.record(z.string(), z.unknown()).optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const ContentTestWidgetSchema = z.object({
    name: z.string(),
    status: z.enum(['draft', 'running', 'completed', 'failed']),
    platform: z.string().optional(),
    contentType: z.string().optional(),
    body: z.string().nullable().optional(),
    mediaAssetId: z.string().nullable().optional(),
    result: ContentTestResultSchema.nullable().optional(),
    personas: z.array(ContentTestPersonaSchema).optional(),
});
